import React, { useState } from 'react'


// components
import SideViewModal from '../../../../../components/modals/SideViewModal/SideViewModal.component'

// collections
import AddItemsToRequest from './AddItemsToRequest.form'

// queries
import { useMutation } from '@apollo/client'
import { BULK_CREATE_EQUIPMENT_REQUEST_ITEMS_FOR_REQUEST } from '../../../../../graphql/equipmentRequestItem/equipmentRequestItem.mutations'
import { apolloClient } from '../../../../..'
import { GET_EQUIPMENT_REQUEST_BY_ID_FOR_PROCESSING, GET_EQUIPMENT_REQUEST_BY_ID_WITH_STATUS, GET_EQUIPMENT_REQUEST_BY_ID_WITH_NOTES, GET_EQUIPMENT_REQUEST_BY_ID_WITH_INFO, GET_EQUIPMENT_REQUEST_BY_ID_WITH_ITEMS } from '../../../../../graphql/equipmentRequest/equipmentRequest.queries'

// utils
import { validate } from '../../../../../shared/utility'
import { createSubmitData } from './EquipmentRequestDetailAddItems.form.controller.utils'

const validationSchema = {
    items: {
        type: 'list',
        fields: {
            id: {
                type: 'input',
                validation: {
                    required: true
                }
            },
            requestedQuantity: {
                type: 'input',
                validation: {
                    required: true,
                    maxAmountField: 'quantity'
                }
            }
        }
    }
}

const EquipmentRequestDetailAddItemsFormController = ({ visible, closeForm, requestId }) => {
    const [isFetchingObject, setIsFetchingObject] = useState(true)
    const [request, setRequest] = useState(null)
    const [createItems] = useMutation(BULK_CREATE_EQUIPMENT_REQUEST_ITEMS_FOR_REQUEST, {
        refetchQueries: [
            {query: GET_EQUIPMENT_REQUEST_BY_ID_WITH_STATUS, variables: { id: parseInt(requestId) }},
            {query: GET_EQUIPMENT_REQUEST_BY_ID_WITH_INFO, variables: { id: parseInt(requestId) }},
            {query: GET_EQUIPMENT_REQUEST_BY_ID_WITH_ITEMS, variables: { id: parseInt(requestId) }},
            {query: GET_EQUIPMENT_REQUEST_BY_ID_WITH_NOTES, variables: { id: parseInt(requestId) }},
        ]
    })
    const [errors, setErrors] = useState({ equipment: [], items: []})

    const handleSubmit = (formData) => {

        const { isValid, errors } = validate(formData, validationSchema)

        if(isValid) {
            createItems({ variables: {...createSubmitData(parseInt(requestId), formData)}}).catch(e => {
                console.error(e)
            }).then(result => {
                if(result) {
                    setErrors({ equipment: [], items: []})
                    closeForm()
                }
            })
        } else {
            setErrors(errors)
        }
    }

    if(visible && isFetchingObject) {
        // fetch the data
        apolloClient.query({ query: GET_EQUIPMENT_REQUEST_BY_ID_FOR_PROCESSING, variables: { id: parseInt(requestId) }}).catch(e => {
            console.error(e)
        }).then(result => {
            if(result) {
                const prefillData = {
                    notes: result.data.equipmentRequest.notes ? result.data.equipmentRequest : "",
                    job: {...result.data.equipmentRequest.job},
                    requestedBy: {...result.data.equipmentRequest.requestedBy},
                    equipment: [...result.data.equipmentRequest.equipmentRequestItemsForEquipmentRequest],
                    truck: result.data.equipmentRequest.truck ? result.data.equipmentRequest.truck.id : null,
                    items: []
                }
                setRequest(prefillData)
                setIsFetchingObject(false)
            }
        })

        return (null)
    }

    else if(visible) {
        const variants = [
            {
                name: 'Add Items',
                component: <AddItemsToRequest requestId={requestId} />,
                stages: 1
            }
        ]

        return (<SideViewModal 
            show={visible} 
            submitText='Add Items'
            onSubmit={handleSubmit}
            onClose={() => {
                setErrors({ items: [] })
                closeForm()
            }} 
            title='Add Items to Request'
            variants={variants}    
            prefillData={request}
            errors={errors}
            />)
    }

    return null
}

export default EquipmentRequestDetailAddItemsFormController